import Client from 'shopify-buy';

const accessToken = '4e5985c67433f3725bd862b7bcdc5df2';
const domain = 'bw-restaurants-oy';
const appId = '6675136539';

export const shopClient = Client.buildClient({
  accessToken: accessToken,
  domain: domain+'.myshopify.com',
  appId: appId
});

export const getProductsInCollection = (collection) =>
  shopClient.fetchQueryProducts({ collection_id: collection })
  .then(response => response)
  .catch(function () {
    console.log('Request failed');
  });


// WEBPACK FOOTER //
// ./src/api/shopifyAPI.js